import { render, staticRenderFns } from "./FundraisingNeeds.vue?vue&type=template&id=5861e29a"
import script from "./FundraisingNeeds.vue?vue&type=script&lang=js"
export * from "./FundraisingNeeds.vue?vue&type=script&lang=js"
import style0 from "./FundraisingNeeds.vue?vue&type=style&index=0&id=5861e29a&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports